import { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { Col, Row, Modal, Button } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  deleteImageAlbum,
  getImageAlbum,
  // deleteImageAlbum,
} from "../../../redux/action/image-album";

function CollectionHome() {
  const { t } = useTranslation();
  const { imageAlbumList } = useSelector((state) => state.imageAlbum);

  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    dispatch(getImageAlbum()).finally(() => setLoading(false));
  }, []);

  const handleDelete = async () => {
    if (!deleteId) return;
    setDeleting(true);
    try {
      await dispatch(deleteImageAlbum(deleteId));
      setDeleteId(null);
      dispatch(getImageAlbum());
    } finally {
      setDeleting(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <TitleComponent
        title="Bộ sưu tập"
        type="primary"
        data="Tạo mới"
        icon={<PlusOutlined />}
        to="/Home/Collection/Create"
        isExist={true}
      />

      <Row gutter={[16, 16]}>
        {imageAlbumList.map((item, index) => (
          <Col key={item.id ?? index} xs={12} sm={8} md={6}>
            <div
              style={{
                position: "relative",
                borderRadius: 12,
                overflow: "hidden",
              }}
            >
              {/* NÚT XOÁ */}
              <Button
                danger
                type="primary"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                loading={deleting && deleteId === item.id}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 10,
                }}
               onClick={(e) => {
  e.stopPropagation();
  if (!item.id) return;   // ⬅️ chặn undefined
  setDeleteId(item.id);
}}

              />

              {/* ẢNH + LINK */}
              <Link to={`/Category/Banner/${item.id}`}>
                <img
                  src={item.imgUrl}
                  alt={`banner-${index}`}
                  style={{
                    width: "100%",
                    height: 180,
                    objectFit: "cover",
                    borderRadius: 12,
                    cursor: "pointer",
                  }}
                />
              </Link>
            </div>
          </Col>
        ))}
      </Row>

      {/* MODAL XÁC NHẬN */}
      <Modal
        open={!!deleteId}
        title="Xác nhận xoá"
        onCancel={() => setDeleteId(null)}
        onOk={handleDelete}
        okText="Xoá"
        cancelText="Huỷ"
        centered
        okButtonProps={{ danger: true, loading: deleting }}
      >
        <p>Bạn có chắc chắn muốn xoá ảnh này không?</p>
      </Modal>
    </div>
  );
}

export default CollectionHome;
